/* eslint-disable no-use-before-define */
//@ts-nocheck

import { Currency } from 'core/../react-billing/constants';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import duration from 'dayjs/plugin/duration';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import { createBrowserHistory } from 'history';
import _filter from 'lodash/filter';
import _find from 'lodash/find';
import _intersectionWith from 'lodash/intersectionWith';
import _omit from 'lodash/omit';
import _pick from 'lodash/pick';
import _uniq from 'lodash/uniq';
import _without from 'lodash/without';
import queryString from 'query-string';
import { toast } from 'react-toastify';
import { createAction } from 'redux-actions';
import { ThunkAction } from 'redux-thunk';

import Mutator from '@magnus/react-native-mutator';
import DeviceProps from '@magnus/react-native-device-props';

import {
  mappingPricesToProducts,
  PaymentSystem,
  ProductInfo,
  type SolidgateMercadoPagoOrder,
  type SolidgatePayPalOrder,
} from '@web-solutions/react-billing';
import { t } from '@web-solutions/module-localization';
import Billing from '@web-solutions/module-billing';
import Analytics from '@web-solutions/module-analytics';
import { getVATMetadata } from '@web-solutions/core/utils/get-vat-metadata';
import { get3DSRedirectURLs } from '@web-solutions/core/utils/billing';
import { reInit as reInitRemoteConfig } from '@web-solutions/core/store/remote-config/actions';
import {
  SubscribeOnOneClickParams,
  SubscribeOnOneClickResponse,
} from '@web-solutions/core/store/billing/types';

import { extractPaymentErrorMessage } from 'core/payment/utils/extract-payment-error-message';
import { stringifyUrlParams } from 'core/utils/url-sync';
import {
  CreatePayPalOrder,
  PaddleConfig,
  Purchase,
  SolidMetadata,
  Subscription,
  SubscriptionProps,
  isOneTimeProductGuard,
} from 'core/interfaces/billing';
import { ProductConfig, RemoteConfig } from 'core/constants/remote-config';
import { ModePayPal } from 'core/constants/billing';

//@ts-ignore
// import { calculateIqScore } from 'core/upsale/utils/calculate-iq-score';

import { remoteConfigSelector } from '../remote-config/selectors';

import { initAppLink } from '../app/actions';

import {
  ProductDetails,
  selectAllProducts,
  selectOneTimePurchases,
  selectPaymentProject,
  selectPaymentSystem,
  selectPurchased,
} from './selectors';

import * as TYPES from './types';

import { getProductsIds, prepareProducts } from './utils';

import { type OneTimePurchase, PaymentMethod } from './index';
import { processEmail } from 'core/store/profile/actions';
import { useAppSelector } from '../hooks';
import { mappingPricesToUpsaleProducts } from '@web-solutions/react-billing/utils/prices';

dayjs.extend(duration);
dayjs.extend(localizedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(utc);

const setIsInitBilling = createAction(TYPES.SET_IS_INIT_BILLING);
const setPaymentSystem = createAction(TYPES.SET_PAYMENT_SYSTEM, (paymentSystem: PaymentSystem) => ({
  paymentSystem,
}));
export const setPurchase = createAction(TYPES.SET_PURCHASE, (purchase: Purchase) => ({ purchase }));
export const resetPurchase = createAction(TYPES.RESET);
export const setPromocodeActivated = createAction(TYPES.SET_PROMOCODE_ACTIVATED);
export const setIsSubmitByCard = createAction<boolean>(TYPES.SET_IS_SUBMIT_BY_CARD);
export const setLoading = createAction(TYPES.SET_LOADING);
export const setPending = createAction(TYPES.SET_PENDING);
const setOrderDetails = createAction(TYPES.SET_ORDER_DETAILS);
const setOrdersPayPal = createAction<Record<string, SolidgatePayPalOrder>>(TYPES.SET_ORDERS_PAYPAL);
export const setOrderPending = createAction(TYPES.SET_ORDER_PENDING);
export const setPaddleConfig = createAction<PaddleConfig>(TYPES.SET_PADDLE_CONFIG);
export const setProducts = createAction<ProductInfo[]>(TYPES.SET_PRODUCTS);
export const setTrialPrice = createAction(TYPES.SET_TRIAL_PRICE);
export const setDiscountEndDate = createAction(TYPES.SET_DISCOUNT_END_DATE);
const setNoFundsOfferEndDate = createAction(TYPES.SET_NO_FUNDS_END_DATE);
const setSpecialOfferEndDate = createAction(TYPES.SET_SPECIAL_OFFER_END_DATE);
const setSpecialOfferProducts = createAction(TYPES.SET_SPECIAL_OFFER_PRODUCTS);
const setNoFundsOfferProducts = createAction(TYPES.SET_NO_FUNDS_OFFER_PRODUCTS);
const setPromocodeOfferProducts = createAction(TYPES.SET_PROMOCODE_OFFER_PRODUCTS);
const setCountryCode = createAction(TYPES.SET_COUNTRY_CODE);
export const setPostCode = createAction<string>(TYPES.SET_POSTCODE);
export const setInjectedPaymentMethod = createAction<string>(TYPES.SET_INJECTED_PAYMENT_METHOD);
export const setOneTimePurchases = createAction<OneTimePurchase[]>(TYPES.SET_ONE_TIME_PURCHASES);
export const setPaymentMethod = createAction<PaymentMethod | null>(TYPES.SET_PAYMENT_METHOD);
export const setTrialsLeftCounter = createAction(TYPES.SET_TRIALS_LEFT_COUNTER);
export const setUpsaleToBasket = createAction(TYPES.SET_UPSALE_TO_BASKET);
export const updateUpsaleInBasket = createAction(TYPES.UPDATE_UPSALE_IN_BASKET);
export const setOneTimePurchaseId = createAction(TYPES.SET_ONE_TIME_PURCHASE_ID);
export const setIsOpenErrorPopup = createAction(TYPES.SET_IS_OPEN_ERROR_POPUP);
export const setIsPaymentOpen = createAction(TYPES.SET_IS_PAYMENT_OPEN);
export const setAccessTokenUserAPI = createAction(TYPES.SET_ACCESS_TOKEN_USER_API);
export const setCardReady = createAction(TYPES.SET_CARD_READY);
export const changePurchaseTokenIdAction = createAction(
  TYPES.CHANGE_PURCHASE_TOKEN_ID,
  (data: string) => data
);
export const setOneTimeProducts = createAction(TYPES.SET_ONE_TIME_PRODUCTS);
export const setActiveProduct = createAction(TYPES.SET_ACTIVE_PRODUCT);
export const setShowDownSaleModalOnce = createAction(TYPES.SET_DOWN_SALE_MODAL_ONCE);
export const setSelectedSpecialOfferProduct = createAction(
  TYPES.SET_SELECTED_SPECIAL_OFFER_PRODUCT
);
export const setCountPPClose = createAction(TYPES.SET_COUNTRY_CODE);
export const setWasOpenPaymentPopup = createAction(TYPES.SET_WAS_OPEN_PAYMENT_POPUP);
export const setIsDisabledButton = createAction(TYPES.SET_IS_DISABLED_BUTTON);
export const setFollowersGrowing = createAction(TYPES.SET_FOLLOWERS_GROWING);
export const setSubscriptionConsentsCheckedList = createAction<boolean[]>(
  TYPES.SET_SUBSCRIPTION_CONSENTS_CHECKED_LIST
);

let initPromise: Promise<any> | null;
let initApiAuthKey: string | null = null;

const syncBillingApiAuth = (state: any, { requireFoodzeeAuth = false } = {}) => {
  const apiAuth = state.profile?.apiAuth;
  const tokenType = apiAuth?.token_type;
  const accessToken = apiAuth?.access_token;

  if (tokenType && accessToken) {
    const apiAuthKey = `${tokenType} ${accessToken}`;
    Billing.setApiAuth(apiAuthKey);
    return apiAuthKey;
  }

  return null;
};

export const init =
  (): ThunkAction<Promise<any>, any, unknown, any> => async (dispatch, getState) => {
    const state = getState();
    const paymentSystem = selectPaymentSystem(state);
    const apiAuthKey = syncBillingApiAuth(state, {
      requireFoodzeeAuth: paymentSystem === PaymentSystem.STRIPE,
    });

    // Only Stripe must wait for the Foodzee auth token before initializing.
    // Other systems (truegate, solidgate, paddle) init as before, using
    // Billing's own auth (boot `auth()` thunk / default headers).
    if (!apiAuthKey && paymentSystem === PaymentSystem.STRIPE) {
      return false;
    }

    if (initPromise && initApiAuthKey !== apiAuthKey) {
      initPromise = null;
    }

    if (!initPromise) {
      const paymentProject = selectPaymentProject(state);

      dispatch(setLoading(true));
      initApiAuthKey = apiAuthKey;

      const p = [
        Billing.init(paymentSystem, paymentProject)
          .then(result => {
            console.log('[BILLING ACTIONS] Billing.init success');
            return result;
          })
          .catch(error => {
            console.error('[BILLING ACTIONS] Billing.init error:', error);
            throw error;
          }),
        dispatch(initDiscount()),
        ...(paymentSystem === PaymentSystem.STRIPE ? [] : [dispatch(initProducts())]),
      ];

      // Skip one-time purchases fetch for Stripe (already handled on email page)
      if (paymentSystem !== PaymentSystem.STRIPE) {
        try {
          const oneTimePurchases = await Billing.getOneTimePurchases();
          dispatch(setOneTimePurchases(oneTimePurchases));
        } catch (e) {
          console.log('[ERROR GET ONE TIME PURCHASES]:', e);
        }
      }

      if (paymentSystem === PaymentSystem.PADDLE) {
        Promise.all([Mutator.getCountryCode(), DeviceProps.getIDFM()])
          .catch(() => [])
          .then(([country, idfm]) => {
            dispatch(
              setPaddleConfig({
                country,
                passthrough: idfm
                  ? JSON.stringify({
                      idfm,
                      payment_system_project: paymentProject,
                    })
                  : undefined,
              })
            );
          });
      }

      initPromise = Promise.all(p)
        .catch((error) => {
          if (initApiAuthKey === apiAuthKey) {
            initPromise = null;
            initApiAuthKey = null;
          }
          console.log('[ERROR INIT BILLING]:', error);
          return false;
        })
        .finally(() => {
          dispatch(setLoading(false));
          dispatch(setIsInitBilling(true));
        });
    }

    return initPromise;
  };

export const checkRedirectResults =
  (): ThunkAction<Promise<Subscription | null>, any, unknown, any> =>
  async (dispatch, getState) => {
    const state = getState();
    const {
      billing: { paddleConfig },
    } = state;

    const qs = queryString.parse(window.location.search);

    if (qs.success === PaymentSystem.PADDLE) {
      const checkout_id = qs.checkout_id || paddleConfig?.checkoutId;
      const product_id = qs.product_id || paddleConfig?.productId;
      const payment_method = qs.payment_method || paddleConfig?.paymentMethod;
      if (checkout_id) {
        createBrowserHistory().replace(
          queryString.stringifyUrl({
            url: window.location.pathname,
            query: _omit(qs, ['success', 'checkout_id', 'product_id', 'payment_method']),
          })
        );
        return dispatch(createCustomer({ paymentSystem: PaymentSystem.PADDLE })).then(() =>
          dispatch(
            subscribe({
              checkout_id: checkout_id,
              price_id: product_id,
              method: payment_method,
              paymentSystem: PaymentSystem.PADDLE,
            })
          )
        );
      }
    } else if (qs.success === 'mercadopago') {
      createBrowserHistory().replace(
        queryString.stringifyUrl({
          url: window.location.pathname,
          query: _omit(qs, ['success', 'product_id', 'amount', 'currency']),
        })
      );
      Analytics.trackEvent('mercadopago', 'success');
      const order_id = window.localStorage.getItem('mercadopago_order_id') || undefined;
      try {
        return dispatch(
          subscribe({
            order_id,
            amount: String(qs.amount),
            currency: String(qs.currency),
            price_id: String(qs.product_id),
            paymentSystem: PaymentSystem.SOLIDGATE,
            method: 'mercadopago',
          })
        );
      } catch (err) {
        dispatch(handleErrorPurchase(err));
      }
    } else if (qs.error === 'mercadopago') {
      createBrowserHistory().replace(
        queryString.stringifyUrl({
          url: window.location.pathname,
          query: _omit(qs, ['error']),
        })
      );
      const e = {
        paymentSystem: PaymentSystem.SOLIDGATE,
        method: 'mercadopago',
      };
      dispatch(handleErrorPurchase(e));
      throw e;
    }
    return null;
  };

const initProducts =
  (): ThunkAction<Promise<void>, any, unknown, any> => async (dispatch, getState) => {
    const state = getState();

    const paymentSystem = selectPaymentSystem(state);

    const { products, specialOffer, noFundsOffer, promocodeOffer } =
      state.remoteConfig as RemoteConfig;

    const PRODUCTS_MAP = [
      {
        products: prepareProducts({ products: products, paymentSystem, attachment: 'default' }),
        condition: products?.length,
        additionalCallback: null,
        productsSetter: setProducts,
      },
      {
        products: prepareProducts({
          products: promocodeOffer?.products,
          paymentSystem,
          attachment: 'promocodeOffer',
        }),
        condition: promocodeOffer?.enabled && promocodeOffer?.products?.length,
        additionalCallback: () => {
          dispatch(setPromocodeActivated(promocodeOffer?.switchDefaultValue));
        },
        productsSetter: setPromocodeOfferProducts,
      },
      {
        products: prepareProducts({
          products: specialOffer?.products,
          paymentSystem,
          attachment: 'specialOffer',
        }),
        condition: specialOffer?.enabled && specialOffer?.products?.length,
        additionalCallback: null,
        productsSetter: setSpecialOfferProducts,
      },
      {
        products: prepareProducts({
          products: noFundsOffer?.products,
          paymentSystem,
          attachment: 'noFundsOffer',
        }),
        condition: noFundsOffer?.enabled && noFundsOffer?.products?.length,
        additionalCallback: null,
        productsSetter: setNoFundsOfferProducts,
      },
    ];

    const allProducts = PRODUCTS_MAP.reduce<ProductConfig[]>(
      (acc, cur) => [...acc, ...cur.products],
      []
    );

    const { subscriptionProducts, oneTimeProducts } = await dispatch(
      fetchProducts({ products: allProducts })
    );

    PRODUCTS_MAP.forEach(({ products, condition, additionalCallback, productsSetter }) => {
      if (condition) {
        //TODO: add auto test for checking products map with same price ids
        const currentProducts = _intersectionWith(
          subscriptionProducts,
          products,
          (cur, inc) => cur.id === inc.id && cur.attachment === inc.attachment
        );
        dispatch(productsSetter(currentProducts));

        if (additionalCallback) {
          additionalCallback();
        }
      }
    });
    dispatch(setOneTimeProducts(oneTimeProducts));

    const { profile } = getState();

    await dispatch(initOrders());
  };

export const initSpecialOfferEndDate =
  (): ThunkAction<Promise<void>, any, unknown, any> => async (dispatch, getState) => {
    const state = getState();
    const { specialOffer } = state.remoteConfig as RemoteConfig;
    dispatch(setSpecialOfferEndDate(dayjs().add(specialOffer.time, 'second')));
  };

export const initNoFundsOfferEndDate =
  (): ThunkAction<Promise<void>, any, unknown, any> => async (dispatch, getState) => {
    const state = getState();
    const { specialOffer } = state.remoteConfig as RemoteConfig;
    dispatch(setNoFundsOfferEndDate(dayjs().add(specialOffer.time, 'second')));
  };

export const getPaymentMethod =
  (): ThunkAction<Promise<PaymentMethod | null>, any, unknown, any> => async (dispatch) => {
    const res = (await Billing.getPaymentMethod()) as any;
    const paymentMethod = res.payment_method;
    dispatch(setPaymentMethod(paymentMethod));
    return paymentMethod;
  };

export const getOneTimePurchases =
  (): ThunkAction<Promise<void>, any, unknown, any> => async (dispatch) => {
    const oneTimePurchases = await Billing.getOneTimePurchases();
    dispatch(setOneTimePurchases(oneTimePurchases));
  };

  export const fetchProducts =
  ({
    products,
    withOneTime = true,
  }: {
    products: ProductConfig[];
    withOneTime?: boolean;
  }): ThunkAction<
    Promise<{ subscriptionProducts: ProductInfo[]; oneTimeProducts: Product[] }>,
    any,
    unknown,
    any
  > =>
  async (dispatch, getState) => {
    const state = getState();

    const { productsDetails, displayVAT, upsaleProducts, usdConversionRates } =
      state.remoteConfig as RemoteConfig;

    const paymentSystem = selectPaymentSystem(state);

    const [country, subscriptionProducts, oneTimeProducts] = await Promise.all([
      Mutator.getCountryCode(),
      Billing.getPrices(getProductsIds(products), { type: 'subscription', paymentSystem }),
      // TODO обрабтать продукты через бэк
      [], // withOneTime ? Billing.getPrices([], { type: 'one_time', paymentSystem }) : [],
    ]);

    dispatch(setCountryCode(country?.toLowerCase()));
    return {
      subscriptionProducts: mappingPricesToProducts({
        products,
        prices: [...subscriptionProducts, ..._filter(productsDetails, { period: 'ONETIME' })],
        countryCode: country || '',
        displayVAT,
        usdConversionRates,
      }),
      oneTimeProducts: mappingPricesToUpsaleProducts({
        products: oneTimeProducts.length ? oneTimeProducts : upsaleProducts,
        countryCode: country || '',
        displayVAT,
        usdConversionRates,
      }),
    };
  };

export const initOrders =
  (): ThunkAction<Promise<void>, any, unknown, any> => async (dispatch, getState) => {
    const state = getState();

    const products = selectAllProducts(state);
    const paymentSystem = selectPaymentSystem(state);
    const { modePayPal } = remoteConfigSelector(state);
    const {
      profile: { email },
    } = state;

    if (!syncBillingApiAuth(state, { requireFoodzeeAuth: paymentSystem === PaymentSystem.STRIPE })) {
      return;
    }

    if (email) {
      await dispatch(createCustomer({}));
    }

    if (paymentSystem === PaymentSystem.STRIPE && !email) {
      return;
    }

    if (paymentSystem === PaymentSystem.TRUEGATE && !email) {
      return;
    }

    const product = products.find((product) => product.default) || products[0];
    if (product) {
      if (paymentSystem === PaymentSystem.SOLIDGATE || paymentSystem === PaymentSystem.TRUEGATE) {
        dispatch(
          createOrders({
            product,
            products: products,
            currency: product.currency,
            paymentSystem,
          })
        );

        if (modePayPal === ModePayPal.SOLIDGATE) {
          dispatch(
            createPayPalOrders({
              paymentSystem,
              products: [product],
              currency: product.currency,
            })
          );
          dispatch(
            createPayPalOrders({
              paymentSystem,
              products: _without(products, product),
              currency: product.currency,
            })
          );
        }
      } else if (paymentSystem === PaymentSystem.PADDLE) {
        const product = products.find((product) => product.default) || products[0];
        dispatch(
          createOrders({
            product: { ...product, id: product.solidgateId! },
            products: products
              .map((p) => ({ ...p, id: p.solidgateId }))
              .filter((p) => !!p.id) as ProductDetails[],
            currency: product.currency,
            paymentSystem: PaymentSystem.SOLIDGATE,
          })
        );
      }
    }
  };

export const initDiscount =
  (): ThunkAction<Promise<void>, any, unknown, any> => async (dispatch, getState) => {
    const {
      remoteConfig: { discountTime: time },
      billing: { discountEndDate },
    } = getState();

    if (time) {
      if (!discountEndDate) {
        dispatch(setDiscountEndDate(dayjs().add(time, 'second')));
      }
    } else {
      if (discountEndDate) {
        dispatch(setDiscountEndDate(null));
      }
    }
  };

export const createCustomer =
  ({
    email,
    paymentSystem,
    paymentProject,
  }: {
    email?: string;
    paymentSystem?: PaymentSystem;
    paymentProject?: string;
  }): ThunkAction<Promise<{ email: string }>, any, unknown, any> =>
  async (dispatch, getState) => {
    try {
      const { profile } = getState();

      email = email || profile.email;
      if (!email) {
        throw new Error('Empty email')
      }

      const { correctAnswersCount } = getState().quiz;
      const { defaultOnboardingType, learningGoal } = getState().remoteConfig;
      let learning_goal;

      // if (learningGoal.isEnabled) {
      //   const { selectedAnswers } = getState().quiz;
      //   learning_goal = selectedAnswers[learningGoal.question]?.answers[0]?.id || null;
      // }

      Analytics.setUserProperty('email', email);

      // Get email from form, otherwise get it from profile. Customer created from paypal won't have email
      
      dispatch(setLoading(true));

      const data = await Billing.createCustomer({
        email,
        paymentSystem,
        paymentProject,
        defaultOnboardingType,
        learningGoal: learning_goal,
      });

      dispatch(setAccessTokenUserAPI(data.token));
      
      if (['virtual-brainary', 'iq-trains', 'iq-boost', 'curiqus'].includes(process.env.REACT_APP_APP_NAME)) {
        const iq = calculateIqScore(correctAnswersCount);
        await Billing.iqCertificateGenerate({ iqPoints: iq, isGenerated: false });
      }

      await dispatch(initAppLink({ token: data.token, ...data.user }));

      return data;
    } catch (error) {
      console.log('[ERROR ASSIGN CUSTOMER]', error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  };

export const createOrders =
  ({
    product,
    products,
    currency,
    paymentSystem,
  }: {
    product: ProductDetails;
    products: ProductDetails[];
    currency: Currency;
    paymentSystem?: PaymentSystem;
  }): ThunkAction<Promise<void>, any, unknown, any> =>
  async (dispatch, getState) => {
    const idfm = await DeviceProps.getIDFM();

    const state = getState();

    const {
      billing: { countryCode },
    } = state;

    const { isSendingTerminateLinks, isSendingTrialEnd, displayVAT } = remoteConfigSelector(state);

    try {
      dispatch(setOrderDetails(null));
      dispatch(setLoading(true));
      const orderDetails = await Billing.createOrder({
        ...(isOneTimeProductGuard(product)
          ? {
              one_time_product: {
                product_id: product.product_id,
                product: product.id,
                amount: product.amount,
                currency: product.currency,
              },
              one_time_products: products.map((p) => ({
                product_id: p.product_id,
                product: p.id,
                amount: p.amount,
                currency: p.currency,
              })),
            }
          : {
              productId: product.id,
              products: _uniq(getProductsIds(products)),
              currency,
            }),
        orderDescription: idfm,
        paymentSystem,
        metadata: getVATMetadata({
          countryCode,
          isAvailable: displayVAT && !product.isOneTimePurchase,
        }),
        is_sending_terminate_links: isSendingTerminateLinks,
        is_sending_trial_end: isSendingTrialEnd,
      });
      orderDetails.productId = product.id;
      dispatch(setOrderDetails(orderDetails));
    } catch (error) {
      console.log('[ERROR CREATE ORDER]', error);
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  };

export const createPayPalOrders =
  ({
    products,
    currency,
    paymentSystem,
    trigger,
    metadata,
    solidMetadata,
  }: CreatePayPalOrder): ThunkAction<Promise<void>, any, unknown, any> =>
  async (dispatch, getState) => {
    const idfm = await DeviceProps.getIDFM();

    const state = getState();

    const {
      billing: { countryCode },
    } = state;

    const { isSendingTerminateLinks, isSendingTrialEnd, displayVAT } = remoteConfigSelector(state);

    dispatch(setOrdersPayPal({}));

    if (products.length) {
      Billing.initAlternativePayment({
        ...(isOneTimeProductGuard(product)
          ? {
              one_time_products: products.map((p) => ({
                product_id: p.product_id,
                product: p.id,
                amount: p.amount,
                currency: p.currency,
              })),
            }
          : {
              products: products.map((p) => p.id),
            }),
        solid_metadata: solidMetadata,
        currency,
        metadata: {
          ...getVATMetadata({
            countryCode,
            isAvailable: displayVAT && !products[0]?.isOneTimePurchase,
          }),
          ...(metadata ? metadata : {}),
        },
        paymentSystem,
        trigger,
        orderDescription: idfm,
        is_sending_terminate_links: isSendingTerminateLinks,
        is_sending_trial_end: isSendingTrialEnd,
        paymentMethod: 'paypal',
      }).then((orders: Record<string, SolidgatePayPalOrder>) => {
        dispatch(setOrdersPayPal(orders));
      });
    }
  };

export const initMercadoPagoPayment =
  (data: {
    product: ProductDetails;
    trigger?: string;
    metadata?: any;
    solidMetadata?: SolidMetadata;
    first_name: string;
    last_name: string;
    taxpayer_id: string;
  }): ThunkAction<Promise<void>, any, unknown, any> =>
  async (dispatch, getState) => {
    const idfm = await DeviceProps.getIDFM();

    dispatch(setLoading(true));

    const state = getState();

    const {
      billing: { countryCode },
    } = state;

    const { isSendingTerminateLinks, isSendingTrialEnd, displayVAT } = remoteConfigSelector(state);

    Analytics.trackEvent('mercadopago', 'init_request');

    // not full href because url is 256 chars max
    const requiredParams = _pick(queryString.parse(window.location.search), [
      'idfm',
      'mode',
      'email',
      'completed',
    ]);

    return Billing.initAlternativePayment({
      ...(isOneTimeProductGuard(product)
        ? {
            one_time_products: [
              {
                product_id: data.product.product_id,
                product: data.product.id,
                amount: data.product.amount,
                currency: data.product.currency,
              },
            ],
          }
        : {
            products: [data.product.id],
          }),
      solid_metadata: data.solidMetadata,
      currency: data.product.currency,
      metadata: {
        ...getVATMetadata({
          countryCode,
          isAvailable: displayVAT && !data.product?.isOneTimePurchase,
        }),
        ...(data.metadata ? data.metadata : {}),
      },
      paymentSystem: PaymentSystem.SOLIDGATE,
      trigger: data.trigger,
      orderDescription: idfm,
      is_sending_terminate_links: isSendingTerminateLinks,
      is_sending_trial_end: isSendingTrialEnd,
      paymentMethod: 'mercadopago',
      first_name: data.first_name,
      last_name: data.last_name,
      taxpayer_id: data.taxpayer_id,
      success_url: queryString.stringifyUrl({
        url: window.location.origin + window.location.pathname,
        query: {
          success: 'mercadopago',
          product_id: data.product.id,
          amount: data.product.trial_price_amount || data.product.amount,
          currency: data.product.currency,
          ...requiredParams,
        },
      }),
      fail_url: queryString.stringifyUrl({
        url: window.location.origin + window.location.pathname,
        query: {
          error: 'mercadopago',
          ...requiredParams,
        },
      }),
      return_url: queryString.stringifyUrl({
        url: window.location.origin + window.location.pathname,
        query: {
          error: 'mercadopago',
          ...requiredParams,
        },
      }),
    })
      .then((r: any) => {
        return r[data.product.id] || r;
      })
      .then((r: SolidgateMercadoPagoOrder | { error: { messages?: string[]; code?: string } }) => {
        if ('error' in r) {
          const e = new Error(
            Object.values(r.error.messages || {})
              .flat()
              .join(', ') || 'Unknown error'
          );
          //@ts-ignore
          e.code = r.error?.code;
          throw e;
        }
        const url = r?.pay_form?.return_url;
        if (url) {
          Analytics.trackEvent('mercadopago', 'redirect_to_ckeckout');
          Analytics.flush();
          window.localStorage.setItem('mercadopago_order_id', r.order.order_id);
          setTimeout(() => {
            window.location.href = url;
          }, 100);
        } else {
          throw new Error('No return url found');
        }
      })
      .catch((e: any) => {
        Analytics.trackEvent('mercadopago', 'init_error', {
          error: e.message,
        });
        e.method = 'mercadopago';
        e.paymentSystem = PaymentSystem.SOLIDGATE;
        dispatch(handleErrorPurchase(e));
        dispatch(setLoading(false));
        throw e;
      });
  };

interface CreateCheckout {
  productId: string;
  checkoutId: string;
  paymentMethod: string;
  paymentSystem: PaymentSystem;
}

export const createCheckout =
  ({
    productId,
    checkoutId,
    paymentMethod,
    paymentSystem,
  }: CreateCheckout): ThunkAction<Promise<void>, any, unknown, any> =>
  async () => {
    try {
      const p = queryString.parse(window.location.search);
      const successUrl = queryString.stringifyUrl({
        url: window.location.origin + window.location.pathname,
        query: {
          ...p,
          success: PaymentSystem.PADDLE,
        },
      });

      await Billing.createCheckout({
        productId,
        checkoutId,
        paymentMethod,
        successUrl,
        paymentSystem,
      });
    } catch (error) {
      console.log('[ERROR CREATE CHECKOUT]', error);
      throw error;
    }
  };

export const handleSuccessPurchase =
  (subscription: Subscription): ThunkAction<Promise<Subscription>, any, unknown, any> =>
  async (dispatch, getState) => {
    const { transaction_id, price_id, plan_name, amount, currency, method, isOneTimePurchase } =
      subscription;

    const actualPlanId = price_id ?? plan_name;

    const state = getState();

    const products = selectAllProducts(state);
    const purchased = selectPurchased(state);
    const oneTimePurchases = selectOneTimePurchases(state);

    const {
      profile: { email },
    } = state;

    const paymentSystem = selectPaymentSystem(state);

    const p =
      _find(products, { id: actualPlanId }) || _find(products, { paypalPlanId: actualPlanId });

    const customerEmail = (subscription as any).customer_email || subscription.email;

    if (customerEmail && customerEmail !== email) {
      dispatch(processEmail(customerEmail));
    }

    if (customerEmail || email || subscription.first_name || subscription.last_name) {
      Analytics.trackEvent('user', 'info', {
        email: customerEmail || email || undefined,
        first_name: subscription.first_name || undefined,
        last_name: subscription.last_name || undefined,
      });
    }

    if (!purchased && !isOneTimePurchase) {
      Analytics.trackPurchaseEvent({
        transactionId: transaction_id,
        productId: actualPlanId,
        revenue: +(p?.trialPriceAmount || p?.amount || amount),
        currency,
        method,
        email,
        paymentSystem: subscription.paymentSystem || paymentSystem,
      });
    }

    if (!isOneTimePurchase || !purchased) {
      dispatch(
        setPurchase({
          ...subscription,
          isTrial: !!p?.isTrial,
          product: p!,
          paymentSystem: subscription.paymentSystem || paymentSystem,
        })
      );
    }

    if (isOneTimePurchase) {
      dispatch(
        setOneTimePurchases([
          ...oneTimePurchases,
          {
            product_code: price_id ?? plan_name,
            payment_service: subscription.paymentSystem || paymentSystem,
            currency,
          },
        ])
      );
    }

    Analytics.setUserProperty('paymentMethod', subscription?.method);
    dispatch(setPaymentMethod(subscription?.method));

    await dispatch(reInitRemoteConfig());

    stringifyUrlParams({ purchased: null });

    return subscription;
  };

export const handleErrorPurchase =
  (
    error: any,
    { noToast }: { noToast: boolean | undefined } = { noToast: false }
  ): ThunkAction<void, any, unknown, any> =>
  (dispatch, getState) => {
    console.warn(error);

    if (!error?.data?.three_d_secure_action_token_id) {
      let customMessage;
      if (error?.paymentSystem === PaymentSystem.SOLIDGATE) {
        customMessage = t(`core.solidgate_payment_errors`, { returnObjects: true })[error?.code];
      }

      if (!noToast) {
        toast(customMessage || error?.message || 'Something went wrong', {
          type: 'error',
          autoClose: customMessage ? 7500 : 5000,
        });
      }

      Analytics.trackEvent('ecommerce', 'error', {
        code: error?.code,
        // The provider's reason as text ("Your card was declined.") — the
        // backend sends no machine-readable decline code.
        message: extractPaymentErrorMessage(error),
        paymentSystem: error?.paymentSystem,
        method: error?.method,
      });
    }
  };

export const subscribe =
  (formData: SubscriptionProps): ThunkAction<Promise<Subscription>, any, unknown, any> =>
  async (dispatch, getState) => {
    const {
      profile: { email },
      remoteConfig: { isSendingTerminateLinks, isSendingTrialEnd, displayVAT, collectEmailAfterPayment },
      billing: { countryCode },
    } = getState();

    const paymentSystem = formData.paymentSystem || selectPaymentSystem(getState());
    // Stripe deferred-email flow: the email is collected after payment, so it
    // must NOT be sent when creating the subscription.
    const deferEmail = collectEmailAfterPayment && paymentSystem === PaymentSystem.STRIPE;

    try {
      dispatch(setPending(true));

      // If we have no email in form, then get it from profile (unless deferred).
      if (!deferEmail && !formData.email && email) {
        formData.email = email;
      }

      // Never send an empty-string email — the backend rejects it with
      // "email must be an email". Omit it entirely (deferred flow / no email yet).
      if (deferEmail || !formData.email) {
        delete formData.email;
      }

      if (formData.email) {
        Analytics.setUserProperty('email', formData.email);
      }

      const subscriptionRes = await Billing.subscribe({
        ...formData,
        metadata: getVATMetadata({ countryCode, isAvailable: displayVAT }),
        is_sending_terminate_links: isSendingTerminateLinks,
        is_sending_trial_end: isSendingTrialEnd,
      });

      const { quiz, remoteConfig } = getState();

      try {
        const { tagsIds, ageGroupId, duration } = remoteConfig.userSaveSettingsSession;

        const bodyUserSession = {
          tagsIds: quiz.selectedAnswers[tagsIds].answers.map((a) => a.id),
          ageGroupId: Number(quiz.selectedAnswers[ageGroupId].answers[0].id),
          duration: Number(quiz.selectedAnswers[duration].answers[0].id),
          pin: null,
        };

        await Billing.saveUserSessionLoopie(bodyUserSession);
      } catch (error) {
        console.log('error save user session', error);
      }

      const subscriptionDetails = {
        ...formData,
        ...subscriptionRes,
      };

      dispatch(setCardReady(false));

      return dispatch(handleSuccessPurchase(subscriptionDetails));
    } catch (error: any) {
      const err = error || {};
      err.paymentSystem = formData.paymentSystem || err.paymentSystem;
      throw error;
    } finally {
      dispatch(setPending(false));
    }
  };

export const applePayOrder =
  (formData: any): ThunkAction<Promise<Subscription>, any, unknown, any> =>
  async (dispatch, getState) => {
    const {
      profile: { email },
      billing: { countryCode },
      remoteConfig: { isSendingTerminateLinks, isSendingTrialEnd, displayVAT },
    } = getState();

    try {
      dispatch(setLoading(true));

      // If we have no email in form, then get it from profile.
      if (!formData.email && email) {
        formData.email = email;
      }

      if (formData.email) {
        Analytics.setUserProperty('email', formData.email);
      }

      const subscriptionRes = await Billing.applePayOrder({
        ...formData,
        metadata: getVATMetadata({ countryCode, isAvailable: displayVAT }),
        is_sending_terminate_links: isSendingTerminateLinks,
        is_sending_trial_end: isSendingTrialEnd,
      });

      const subscriptionDetails = {
        ...formData,
        amount: subscriptionRes?.order?.amount / 100 || undefined,
        currency: subscriptionRes?.order?.currency,
        method: 'applepay',
        order: subscriptionRes?.order,
        transaction_id: subscriptionRes?.order?.subscription_id,
      };

      return dispatch(handleSuccessPurchase(subscriptionDetails));
    } catch (error: any) {
      const err = error || {};
      err.paymentSystem = formData.paymentSystem || err.paymentSystem;
      throw error;
    } finally {
      dispatch(setLoading(false));
    }
  };

export const checkActiveSubscription =
  (args: { isAsb?: boolean }): ThunkAction<Promise<[] | undefined>, any, unknown, any> =>
  //@ts-ignore
  async (dispatch, getState) => {
    try {
      const {
        billing: { purchase },
      } = getState();

      if (purchase) {
        const { data } = await Billing.getSubscriptions(args?.isAsb);

        if (data) {
          const isActiveSubscription = data.some((subscription: any) => subscription?.active);

          if (!isActiveSubscription) {
            window.localStorage.clear();
            const p = queryString.parse(window.location.search);
            delete p.completed;
            delete p.purchased;
            createBrowserHistory().replace(
              window.location.pathname + '?' + queryString.stringify(p)
            );
          }
          return data;
        }
      }
    } catch (error) {
      console.log('[ERROR GET SUBSCRIPTIONS]', error);
    }
  };

export const changePlan =
  (
    productId: string,
    subscriptionId: string,
    isNewSubscription: boolean
  ): ThunkAction<Promise<any>, any, unknown, any> =>
  async (dispatch) => {
    dispatch(setLoading(true));
    try {
      const { failUrl, successUrl } = get3DSRedirectURLs();

      const r =
        (await Billing.changePlan({
          subscriptionId,
          productId,
          isNewSubscription,
          successUrl,
          failUrl,
        })) || {};

      console.log(r);

      return r;
    } finally {
      dispatch(setLoading(false));
    }
  };

export const switchToReservePaymentSystem =
  (): ThunkAction<Promise<void>, any, unknown, any> => async (dispatch, getState) => {
    const state = getState();
    const paymentSystem = selectPaymentSystem(state);
    const { paymentSystemReserve } = state.remoteConfig;

    if (paymentSystemReserve && paymentSystem !== paymentSystemReserve) {
      dispatch(setPaymentSystem(paymentSystemReserve));
      initPromise = null;
      dispatch(init());
    }
  };

interface OneClickPaymentArgs {
  amount: number;
  currency: Currency;
  productCode: string;
  productId: string;
  withTransactionDetailsEmail?: boolean;
  force3ds?: boolean;
  trigger?: string;
  metadata?: { chatId?: string };
  solidMetadata?: SolidMetadata;
  transactionId: string;
}

export const subscribeOnOneClick =
  (
    params: SubscribeOnOneClickParams
  ): ThunkAction<Promise<SubscribeOnOneClickResponse>, any, unknown, any> =>
  async (_, getState) => {
    const {
      billing: { countryCode },
      remoteConfig: { displayVAT },
    } = getState();

    const { failUrl, successUrl } = get3DSRedirectURLs();

    return await Billing.subscribeOnOneClick({
      ...params,
      metadata: getVATMetadata({ countryCode, isAvailable: displayVAT }),
      success_url: successUrl,
      fail_url: failUrl,
    });
  };

export const createOneClickPayment =
  ({
    amount,
    currency,
    productCode,
    productId,
    trigger = '',
    force3ds,
    metadata,
    solidMetadata,
    withTransactionDetailsEmail,
    transactionId
  }: OneClickPaymentArgs): ThunkAction<Promise<void>, any, unknown, any> =>
  //@ts-ignore
  async () => {
    const { failUrl, successUrl } = get3DSRedirectURLs();

    const description = await DeviceProps.getIDFM();
    const data = await Billing.createOneClickPayment({
      withTransactionDetailsEmail,
      force3ds,
      amount,
      currency,
      productCode,
      productId,
      successUrl,
      failUrl,
      trigger,
      metadata,
      solidMetadata,
      description,
      transactionId
    });

    const resData = data.data || data
    return {
      ...data,
      data: {
        ...resData,
        payment_service: resData.paymentService,
        product_code: resData.productCode,
        order_id: resData.orderId,
        created_at: resData.createdAt,
        updated_at: resData.updatedAt,
        readable_created_at: resData.readableCreatedAt,
        readable_updated_at: resData.readableUpdatedAt,
      },
    };
  };

export const createOneClickFreePayment =
  (productId: string, transactionId?: string): ThunkAction<Promise<void>, any, unknown, any> =>
  async () => {
    return Billing.createOneClickFreePayment(productId, transactionId);
  };
